<template>
  <component :is="component" v-if="component" />
</template>
<script>
export default {
  name: 'LogbookIndex',
  data() {
    return {
      component: null
    }
  },
  computed: {
    specialty() {
      return this.$store.getters.specialty
    },
    loader() {
      // TODO: This code is very hard to find and if not changed for every new specialy, breaks everything
      // Should be refactored (maybe just drop LegacyLogbook) when we have time
      return () => import('./Logbook')
    }
  },
  mounted() {
    this.loader().then(() => {
      this.component = () => this.loader()
    })
  }
}
</script>
